// a lógica agora se concentra em createGrupoAtivosHook.js
import { createGrupoAtivosHook } from "./createGrupoAtivosHook"

export const useGrupoAtivos = createGrupoAtivosHook(['Corporate', 'IF', 'IF_IQ', 'Soberano'])